import { render, staticRenderFns } from "./CadastreBuildingList.vue?vue&type=template&id=6ce8bf07&scoped=true&"
import script from "./CadastreBuildingList.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8bf07",
  null
  
)

export default component.exports